import * as React from "react";

import { DiagnosisStepChip, DiagnosisStepChipsRow } from "@/components/diagnosis/DiagnosisStepChip";
import { isExpoRegistration } from "@/utilities/expoRegistration";

import { DIAGNOSIS_STEP_CHIP_LABELS } from "../diagnosis/diagnosisFlowStepDefinitions";

export const RegistrationPhases: React.FC<{ completed?: boolean }> = ({ completed = false }) => {
  // エキスポ導線（Trello #241）では投資スタイル診断を飛ばすため、受けないステップを「これから」として出さない。
  // 入口の種別は表示中に変わらないので、マウント時に1回だけ目印を読む（レンダーごとに localStorage を読まない）
  const [isExpo] = React.useState(() => isExpoRegistration());

  return (
    <DiagnosisStepChipsRow>
      <DiagnosisStepChip
        animate
        v2
        label={DIAGNOSIS_STEP_CHIP_LABELS.investment}
        state={completed ? "completed" : "active"}
        withCheck={completed}
      />
      {!isExpo && <DiagnosisStepChip v2 label={DIAGNOSIS_STEP_CHIP_LABELS.style} state="upcoming" withCheck={false} />}
      <DiagnosisStepChip v2 label={DIAGNOSIS_STEP_CHIP_LABELS.planner} state="upcoming" withCheck={false} />
    </DiagnosisStepChipsRow>
  );
};
